export default {"src":"/_next/static/media/podcast-star-filled.cbd6349d.svg","height":23,"width":24};